import type { ReactNode } from "react";
import { cn } from "../lib/cn";

function BrandLoader() {
  return (
    <div className="absolute inset-0 z-[1111] flex flex-col items-center justify-center gap-4 backdrop-blur-sm bg-theme-slate-800 rounded-[inherit]">
      {/* Dual-ring spinner */}
      <div className="relative flex items-center justify-center size-14">
        {/* Outer ring — slow clockwise */}
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-theme-primary border-r-theme-primary/30 animate-spin [animation-duration:1.2s]" />
        {/* Inner ring — faster counter-clockwise */}
        <div className="absolute inset-[6px] rounded-full border-2 border-transparent border-b-theme-primary/70 border-l-theme-primary/20 animate-spin [animation-duration:0.8s] [animation-direction:reverse]" />
        {/* Center dot */}
        <div className="size-2 rounded-full bg-theme-primary animate-pulse" />
      </div>

      {/* Label */}
      <span className="text-xs font-medium tracking-widest uppercase text-theme-gray-400 animate-pulse">
        Loading
      </span>
    </div>
  );
}

const WithLoader = ({
  children,
  isLoading,
  className,
}: {
  children: ReactNode;
  isLoading: boolean;
  height?: number;
  className?: string;
}) => {
  return (
    <div className={cn(isLoading && "relative overflow-hidden", className)}>
      {isLoading && <BrandLoader />}
      {children}
    </div>
  );
};

export default WithLoader;
